module.exports = __webpack_public_path__ + "img/BRCA4_Myofibroblasts.fd8242c1.png";